<template>
    <div class="page" :style="'height:'+innerHeight+'px'" v-show="bodyShow">

        <div class="video-col" :style="'height:'+height+'px'" v-if="live_params.status == 'stop' || !live_params.type">
            <div class="video-no" v-if="params.is_own == 0">
                <van-image :src="params.cover+'?x-oss-process=style/w750'" fit="cover"/>
            </div>
            <div class="video-no" v-if="params.is_own == 1">
                <van-image :src="params.cover+'?x-oss-process=style/w750'" fit="cover"/>
                <div class="video-mask">
                    <div class="video-mask-info">
                        <span class="iconfont iconshizhong1"></span>
                        <span class="video-mask-txt">请耐心等待，讲师马上回来~</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 直播区域 -->
        <div class="live-zone">
          <!-- PPT+摄像头直播 -->
          <div class="camera-video" v-if="live_params.type=='video_ppt' && params.is_own == 1 && live_params.status != 'stop'">
              <div class="camera-video-player">
                  <video-player v-if="!webrtc_issupport" class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                id="camera"
                                :playsinline="true"
                                :options="playerOptions"
                                style="height:50px;width:100px"
                                @ready="playerReadied"
                                @play="onPlayerPlay($event)"
                                @pause="onPlayerPause($event)"
                                @timeupdate="onPlayerTimeupdate($event)"
                  ></video-player>
              </div>
              <div class="camera-video-btn">
                  <div :class="'tip '+(videoPPTStatus?'stop':'')">{{videoPPTStatus?'· 视频直播失败':'· 视频直播中'}}</div>
                  <div v-if="!webrtc_issupport" class="camera-video-play" @click="videoPlay">
                      <span :class="'iconfont '+(videoCameraPlay?'iconbofang1':'iconbofang11')"></span>
                  </div>
                  <div v-if="!webrtc_issupport" class="camera-fullscreen" @click="videoFullscreen">
                      <span class="iconfont iconquanping1"></span>
                  </div>
              </div>
          </div>
          <div class="video-col" @touchmove="livePPTTouchmove" :style="'height:'+height+'px'" v-if="live_params.type=='video_ppt' && params.is_own == 1 && live_params.status != 'stop'">
              <div class="video-no">
                  <van-image :src="live_params.ppts[live_params.page-1]" fit="cover" @click.stop="openLivePPT"/>
                  <div class="custom-indicator">
                      <span style="font-size: 16px">{{ live_params.page }}</span>/{{live_params.ppts.length}}
                  </div>
              </div>
          </div>

          <!--屏幕共享 || 摄像头直播-->
          <div class="video-col video-content" :style="'height:'+height+'px'"
              v-if="(live_params.type == 'screen' || live_params.type == 'video') && params.is_own == 1 && live_params.status != 'stop'">
              <div class="video-no">
                  <video-player v-if="!webrtc_issupport" class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                id="videoPlayer"
                                :playsinline="true"
                                :options="playerOptions"
                                :style="'height:'+height+'px'"
                                @ready="playerReadied"
                  ></video-player>
              </div>
          </div>

          <video
            v-if="(live_params.type == 'screen' || live_params.type == 'video' || live_params.type == 'video_ppt') && params.is_own == 1 && live_params.status != 'stop' && webrtc_issupport"
            ref="webrtc_live"
            id="webrtc_live"
            :poster="poster"
            :style="'height:'+live_height+'px;width:'+live_width+''"
            autoplay unmuted playsinline 
            :controls="playerOptions.controls"
            >
          </video>
        </div>
        <div class="msg-col">
            <div class="table">
                <div :class="'tab-li '+(type == 'kc'?'curr':'')" @click="bindType('kc')">课程</div>
                <div :class="'tab-li '+(type == 'hd'?'curr':'')" @click="bindType('hd')">互动</div>
            </div>
            <div class="table-content">

                <div class="table-content-li kc" v-show="type == 'kc'">
                    <div class="live-name">
                        {{params.name}}
                    </div>
                    <div class="live-lecturer">{{params.lecturer}}</div>
                    <div class="live-brief-introduction">课程简介</div>
                    <div class="live-brief-txt">{{params.desc}}</div>
                    <div class="live-course-time">{{params.live_start_time}}</div>
                    <div v-html="params.content"></div>
                </div>

                <div class="table-content-li hd" @scroll="msgScroll" @click="removeReplyMsg" v-show="type == 'hd'">
                    <div class="live-msg">

                        <van-loading size="16px" style="text-align: center" v-if="is_loading">加载中...</van-loading>

                        <!--实时消息-->
                        <div class="text-msg" v-if="msg_list.length > 0">

                            <div class="live-msg-list">
                                <div class="live-msg-li clearfix "
                                     v-for="(item,index) in msg_list"
                                     :key="index"
                                     v-if="(item.room.ext && item.room.ext.userRole != '学员') || (item.room.userInfo.userId && item.room.userInfo.userId == user_id)">

                                    <div class="live-msg-time" v-if="item.chat_gap_time && item.chat_gap_time != ''">{{item.chat_gap_time}}</div>

                                    <!-- 自己的消息-->
                                    <div v-if="item.room.userInfo.userId == user_id">
                                        <div class="user-img fr">
                                            <van-image :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'" fit="cover"/>
                                        </div>
                                        <div class="user-info fr clearfix mr">
                                            <div class="user-name clearfix fs2">
                                                <span class="fr">{{item.room.userInfo.name}}<span class="user-lecturer" v-if="item.room.ext && item.room.ext.userRole && item.room.ext.userRole != '学员'">{{item.room.ext.userRole}}</span></span>
                                            </div>
                                            <span class="withdraw-msg" @click.stop="withdrawMsgEvent(item.uuid)">撤回</span>
                                            <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'text'">{{item.room.message.text.content}}</div>
                                            <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'ask'"><span class="question-sign">问</span>{{item.room.message.ask.content}}</div>
                                            <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'quote'">
                                                <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'text'">
                                                    <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                    <span>{{item.room.message.quote.fromMessage.message.text.content}}</span>
                                                </div>
                                                <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'ask'">
                                                    <span class="question-sign">问</span>
                                                    <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                    <span>{{item.room.message.quote.fromMessage.message.ask.content}}</span>
                                                </div>
                                                <van-divider :dashed="true" style="margin: 10px 0"/>
                                                <div class="reply-content">
                                                    {{item.room.message.quote.content}}
                                                </div>
                                            </div>


                                            <div class="live-msg-img" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'images'" @click.stop="openImagePreview(item.room.message.images.url)">
                                                <van-image radius="5" :src="item.room.message.images.url+'?x-oss-process=style/w750'" fit="cover"/>
                                            </div>

                                            <div class="live-msg-card"
                                                 :style="'max-width:'+msgWidth+'px'"
                                                 v-if="item.room.message.type == 'card'"
                                                 @click.stop="jumpEvent(item.room.message.card.ext)">
                                                <van-image radius="5" :src="item.room.message.card.image+'?x-oss-process=style/w750'" fit="cover"/>
                                                <span>{{item.room.message.card.title}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!---别人的消息-->
                                    <div v-if="item.room.userInfo.userId != user_id">
                                        <div class="user-img">
                                            <van-image :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'" fit="cover"/>
                                        </div>
                                        <div class="user-info">
                                            <div class="user-name"><span class="user-lecturer" v-if="item.room.ext && item.room.ext.userRole">{{item.room.ext.userRole}}</span>{{item.room.userInfo.name}}</div>
                                            <div class="user-content" @click.stop="replyMsg(item,item.room.message)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'text'">{{item.room.message.text.content}}</div>
                                            <div class="user-content" @click.stop="replyMsg(item,item.room.message)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'ask'"><span class="question-sign">问</span>{{item.room.message.ask.content}}</div>
                                            <div class="user-content" @click.stop="replyMsg(item,item.room.message.quote)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'quote'">
                                                <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'text'">
                                                    <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                    <span>{{item.room.message.quote.fromMessage.message.text.content}}</span>
                                                </div>
                                                <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'ask'">
                                                    <span class="question-sign">问</span>
                                                    <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                    <span>{{item.room.message.quote.fromMessage.message.ask.content}}</span>
                                                </div>
                                                <van-divider :dashed="true" style="margin: 10px 0"/>
                                                <div class="reply-content">
                                                    {{item.room.message.quote.content}}
                                                </div>
                                            </div>

                                            <div class="live-msg-img" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'images'" @click.stop="openImagePreview(item.room.message.images.url)">
                                                <van-image radius="5" :src="item.room.message.images.url+'?x-oss-process=style/w750'" fit="cover"/>
                                            </div>

                                            <div class="live-msg-card"
                                                 :style="'max-width:'+msgWidth+'px'"
                                                 v-if="item.room.message.type == 'card'"
                                                 @click.stop="jumpEvent(item.room.message.card.ext)">
                                                <van-image radius="5" :src="item.room.message.card.image+'?x-oss-process=style/w750'" fit="cover"/>
                                                <span>{{item.room.message.card.title}}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="message-retrying" v-if="messageRetrying">{{tips}}</div>
                </div>

                <div class="live-room-info" v-if="type == 'hd'">
                    <span>直播人次：{{roomInfo.times}}</span>
                </div>

                <!--提示购买课程-->
                <div class="live-no-own" v-if="type == 'hd' && params.is_own == 0">
                    <div class="live-own-tip">
                        <span class="iconfont iconsuo fs30"></span>
                        <div class="mt5">请先{{params.sell_mode == 1?'购买':'领取'}}课程</div>
                    </div>
                </div>

                <!--底部按钮-->
                <div class="live-btn" v-if="type == 'hd' && params.is_own == 1">
                    <div class="live-btn-text">
                        <van-field
                                v-model="msg_input"
                                rows="1"
                                :autosize="autosize"
                                type="textarea"
                                @focus="msgFocus"
                                @blur="msgBlur"
                                :placeholder="placeholder"
                        >
                            <template #button class="live-btn-checkbox" v-if='!replyMsgParams.uuid'>
                                <van-checkbox icon-size="12px" v-model="checked" checked-color="#3a3a3a">提问</van-checkbox>
                            </template>
                        </van-field>
                    </div>

                    <div class="live-discuss-module" v-if="discuss" @click="openDiscuss">
                        <van-icon name="chat-o" color="#999" size="25"/>
                    </div>

                    <div class="live-msg-save" v-if="!discuss"  @click="sendMsgChat">
                        发送
                    </div>
                </div>

                <div class="bottom-new-news aaa"
                     v-if="bottomNewNews && type == 'hd' && params.is_own == 1 && discuss_module_type=='tl'" @click="scrollTo(1)">
                    <span>底部有新消息</span>
                </div>

                <div class="bottom-new-news bbb"
                     v-if="askBottomNewNews && type == 'hd' && params.is_own == 1 && discuss_module_type=='tw'" @click="scrollTo(1)">
                    <span>底部有新消息</span>
                </div>
            </div>

            <div v-if="type == 'hd' && params.is_own == 1">
                <div class="to-bottom" v-if="toBottom && discuss_module_type=='tl'" @click="scrollTo(1)">
                    <span class="iconfont iconxiala"></span>
                </div>

                <div class="to-bottom" v-if="askToBottom && discuss_module_type=='tw'" @click="scrollTo(1)">
                    <span class="iconfont iconxiala"></span>
                </div>

                <div class="barrage-list" v-if="bulletChat && bulletChatList.length > 0" :style="'bottom:'+(toBottom?145:110)+'px'">
                    <div class="barrage-item" v-for="(item,index) in bulletChatList"
                         :key="index" @click="openDiscuss">
                        <div class="barrage-item-txt">

                            <span class="content-area" v-if="item.room.message.type == 'text'">{{item.room.message.text.content}}</span>

                            <span class="question-tip" v-if="item.room.message.type == 'ask'">问</span>
                            <span class="content-area" v-if="item.room.message.type == 'ask'">{{item.room.message.ask.content}}</span>

                        </div>
                        <div class="barrage-item-img">
                            <img :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'">
                        </div>
                    </div>
                </div>

                <div class="bullet-chat" :style="'bottom:'+(toBottom?100:66)+'px'" @click="bulletChatEvent">
                <span :class="'iconfont '+(bulletChat?'icondanmukai':'icondanmuguan')"></span>
            </div>
            </div>
        </div>

        <!--讨论区-->
        <van-action-sheet v-model="discuss_module" :overlay="false" :round="false" :style="'height:'+(discussHeight-(live_params.type=='video_ppt'?50:0))+'px;'" class="discuss-module">
            <div class="discuss-head">
                <div :class="'discuss-head-col '+(discuss_module_type == 'tl'?'curr':'')" @click="bindDiscussModuleType('tl')">讨论区</div>
                <div :class="'discuss-head-col '+(discuss_module_type == 'tw'?'curr':'')" @click="bindDiscussModuleType('tw')">提问区</div>
                <div class="discuss-head-close" @click="closeDiscuss">
                    <van-icon name="cross" size="16" color="#999"/>
                </div>
            </div>

            <!--讨论区-->
            <div class="table-content-li hd discuss" v-show="discuss_module_type == 'tl'" @scroll="msgScroll" @click="removeReplyMsg" style="top: 49px;padding-top: 0">

                <van-loading size="16px" style="text-align: center" v-if="is_loading">加载中...</van-loading>

                <div class="live-msg">

                    <div class="text-msg" v-if="msg_list.length > 0">

                        <div class="live-msg-list">
                            <div class="live-msg-li clearfix "
                                 v-for="(item,index) in msg_list"
                                 :key="index">

                                <div class="live-msg-time" v-if="item.chat_gap_time && item.chat_gap_time != ''">{{item.chat_gap_time}}</div>

                                <!-- 自己的消息-->
                                <div v-if="item.room.userInfo.userId == user_id">
                                    <div class="user-img fr">
                                        <van-image :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'" fit="cover"/>
                                    </div>
                                    <div class="user-info fr clearfix mr">
                                        <div class="user-name clearfix fs2">
                                            <span class="fr">{{item.room.userInfo.name}}<span class="user-lecturer" v-if="item.room.ext && item.room.ext.userRole && item.room.ext.userRole != '学员'">{{item.room.ext.userRole}}</span></span>
                                        </div>
                                        <span class="withdraw-msg" @click.stop="withdrawMsgEvent(item.uuid)">撤回</span>
                                        <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'text'">{{item.room.message.text.content}}</div>
                                        <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'ask'"><span class="question-sign">问</span>{{item.room.message.ask.content}}</div>
                                        <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'quote'">
                                            <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'text'">
                                                <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                <span>{{item.room.message.quote.fromMessage.message.text.content}}</span>
                                            </div>
                                            <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'ask'">
                                                <span class="question-sign">问</span>
                                                <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                <span>{{item.room.message.quote.fromMessage.message.ask.content}}</span>
                                            </div>
                                            <van-divider :dashed="true" style="margin: 10px 0"/>
                                            <div class="reply-content">
                                                {{item.room.message.quote.content}}
                                            </div>
                                        </div>

                                        <div class="live-msg-img" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'images'" @click.stop="openImagePreview(item.room.message.images.url)">
                                            <van-image radius="5" :src="item.room.message.images.url+'?x-oss-process=style/w750'" fit="cover"/>
                                        </div>

                                        <div class="live-msg-card"
                                             :style="'max-width:'+msgWidth+'px'"
                                             v-if="item.room.message.type == 'card'"
                                             @click.stop="jumpEvent(item.room.message.card.ext)">
                                            <van-image radius="5" :src="item.room.message.card.image+'?x-oss-process=style/w750'" fit="cover"/>
                                            <span>{{item.room.message.card.title}}</span>
                                        </div>
                                    </div>
                                </div>

                                <!---别人的消息-->
                                <div v-if="item.room.userInfo.userId != user_id">
                                    <div class="user-img">
                                        <van-image :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'" fit="cover"/>
                                    </div>
                                    <div class="user-info">
                                        <div class="user-name"><span class="user-lecturer" v-if="item.room.ext && item.room.ext.userRole">{{item.room.ext.userRole}}</span>{{item.room.userInfo.name}}</div>
                                        <div class="user-content" @click.stop="replyMsg(item,item.room.message)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'text'">{{item.room.message.text.content}}</div>
                                        <div class="user-content" @click.stop="replyMsg(item,item.room.message)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'ask'"><span class="question-sign">问</span>{{item.room.message.ask.content}}</div>
                                        <div class="user-content" @click.stop="replyMsg(item,item.room.message.quote)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'quote'">
                                            <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'text'">
                                                <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                <span>{{item.room.message.quote.fromMessage.message.text.content}}</span>
                                            </div>
                                            <div class="reply-content" v-if="item.room.message.quote.fromMessage.message.type == 'ask'">
                                                <span class="question-sign">问</span>
                                                <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                <span>{{item.room.message.quote.fromMessage.message.ask.content}}</span>
                                            </div>
                                            <van-divider :dashed="true" style="margin: 10px 0"/>
                                            <div class="reply-content">
                                                {{item.room.message.quote.content}}
                                            </div>
                                        </div>

                                        <div class="live-msg-img" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'images'" @click.stop="openImagePreview(item.room.message.images.url)">
                                            <van-image radius="5" :src="item.room.message.images.url+'?x-oss-process=style/w750'" fit="cover"/>
                                        </div>

                                        <div class="live-msg-card"
                                             :style="'max-width:'+msgWidth+'px'"
                                             v-if="item.room.message.type == 'card'"
                                             @click.stop="jumpEvent(item.room.message.card.ext)">
                                            <van-image radius="5" :src="item.room.message.card.image+'?x-oss-process=style/w750'" fit="cover"/>
                                            <span>{{item.room.message.card.title}}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--提问区-->
            <div class="table-content-li hd ask" v-show="discuss_module_type == 'tw'" @scroll="msgScroll" @click="removeReplyMsg" style="top: 49px;padding-top: 0">

                <van-loading size="16px" style="text-align: center" v-if="ask_is_loading">加载中...</van-loading>

                <div class="live-msg">

                    <div class="text-msg" v-if="ask_list.length > 0">

                        <div class="live-msg-list" v-show="discuss_module_type == 'tw'">
                            <div class="live-msg-li clearfix "
                                 v-for="(item,index) in ask_list"
                                 :key="index">

                                <div class="live-msg-time" v-if="item.chat_gap_time && item.chat_gap_time != ''">{{item.chat_gap_time}}</div>

                                <!-- 自己的消息-->
                                <div v-if="item.room.userInfo.userId == user_id">
                                    <div class="user-img fr">
                                        <van-image :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'" fit="cover"/>
                                    </div>
                                    <div class="user-info fr clearfix mr">
                                        <div class="user-name clearfix fs2">
                                            <span class="fr">{{item.room.userInfo.name}}<span class="user-lecturer" v-if="item.room.ext && item.room.ext.userRole && item.room.ext.userRole != '学员'">{{item.room.ext.userRole}}</span></span>
                                        </div>
                                        <span class="withdraw-msg" @click.stop="withdrawMsgEvent(item.uuid)">撤回</span>
                                        <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'ask'"><span class="question-sign">问</span>{{item.room.message.ask.content}}</div>
                                        <div class="user-content" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'quote'">
                                            <div class="reply-content">
                                                <span class="question-sign">问</span>
                                                <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                <span>{{item.room.message.quote.fromMessage.message.ask.content}}</span>
                                            </div>
                                            <van-divider :dashed="true" style="margin: 10px 0"/>
                                            <div class="reply-content">
                                                {{item.room.message.quote.content}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!---别人的消息-->
                                <div v-if="item.room.userInfo.userId != user_id">
                                    <div class="user-img">
                                        <van-image :src="item.room.userInfo.headimgurl+'?x-oss-process=style/w64-h64'" fit="cover"/>
                                    </div>
                                    <div class="user-info">
                                        <div class="user-name"><span class="user-lecturer" v-if="item.room.ext && item.room.ext.userRole">{{item.room.ext.userRole}}</span>{{item.room.userInfo.name}}</div>
                                        <div class="user-content" @click.stop="replyMsg(item,item.room.message)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'ask'"><span class="question-sign">问</span>{{item.room.message.ask.content}}</div>
                                        <div class="user-content" @click.stop="replyMsg(item,item.room.message.quote)" :style="'max-width:'+msgWidth+'px'" v-if="item.room.message.type == 'quote'">
                                            <div class="reply-content">
                                                <span class="question-sign">问</span>
                                                <span>{{item.room.message.quote.fromMessage.userInfo.name}}：</span>
                                                <span>{{item.room.message.quote.fromMessage.message.ask.content}}</span>
                                            </div>
                                            <van-divider :dashed="true" style="margin: 10px 0"/>
                                            <div class="reply-content">
                                                {{item.room.message.quote.content}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="live-btn">
                <div class="live-btn-text">
                    <van-field
                            v-model="msg_discuss_input"
                            rows="1"
                            :autosize="autosize"
                            type="textarea"
                            @blur="msgDiscussBlur"
                            :placeholder="placeholder"
                    >
                        <template #button class="live-btn-checkbox" v-if='!replyMsgParams.uuid'>
                            <van-checkbox icon-size="12px" v-model="discuss_checked" checked-color="#3a3a3a">提问</van-checkbox>
                        </template>
                    </van-field>
                </div>

                <div class="live-msg-save"  @click="sendDiscussMsgChat">
                    发送
                </div>
            </div>
        </van-action-sheet>

        <!--免费-->
        <div class="make-an-appointment" v-if="params.sell_mode == 2 && params.is_own == 0">
            <div class="make-an-appointment-text" style="background-color:#00CC00" @click="bindOrderCourse">立即领取</div>
        </div>

        <!-- 购买 -->
        <div class="make-an-appointment" v-if="params.sell_mode == 1 && params.is_own == 0">
            <div class="share" @click="is_show_share = true"><span class="iconfont iconfenxiang"></span></div>
            <div class="trial-class" style="display:none">试课</div>

            <div class="make-an-appointment-text" v-if="params.is_own == 0" @click="bindApply">立即购买（￥ {{params.money}}）</div>
            <div class="make-an-appointment-text" style="background-color:#00CC00" v-if="params.is_own == 1">已购买</div>
        </div>

        <share :is_show_share="is_show_share" v-on:hideShare="hideShare"></share>

        <authorize_mobile v-on:usergrantcallback="usergrantcallback" :visible="visible"></authorize_mobile>
    </div>
</template>

<script>
    var socket = null;
    var playerReadiedTime = null;
    var pingInterval = null;
    import {Image as VanImage,Button,Divider,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem} from 'vant';
    import share from '../../components/common/share';
    import authorize_mobile from '../../components/common/authorize_mobile';
    import env from '@/utils/env'
    import wx from "weixin-js-sdk";

    // import VConsole from "vconsole";
    // var vConsole = new VConsole();

    import adapter from '@/assets/js/rtc/adapter.js';  
    import client from '@/assets/js/rtc/Browser.js';  
    import DectectRTC from '@/assets/js/rtc/DectectRTC.js'
    import $ from 'jquery';

    var WeChat;
    export default {
        name: "index",
        components:{
            [VanImage.name]:VanImage,
            [Divider.name]:Divider,
            [Field.name]:Field,
            [Checkbox.name]:Checkbox,
            [Icon.name]:Icon,
            [ActionSheet.name]:ActionSheet,
            [Loading.name]:Loading,
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            [Button.name]:Button,
            share,authorize_mobile,
            DectectRTC,
            client,
            adapter,
        },
        data(){
            return {
                visible:false,
                bodyShow:false,
                height:0,
                live_width: '100%',
                live_height: 0,
                msgWidth:0,
                innerHeight:0,
                liveMsgImgW:0, // 消息区域图片宽
                liveMsgImgH:0,// 消息区域图片高
                params:{},
                indexes:0,// 漫游消息分页起始位
                msg_list:[], // 总体消息 漫游+实时
                room_list:[], //实时消息
                room_list_total:0,

                ask_list:[], // 提问消息
                ask_indexes:0, // 提问消息分页起始位
                ask_more:false, // 提问消息是否有更多
                ask_is_loading:false,//提问消息显示加载中
                askBottomNewNews:false,
                askToBottom:false,
                ask_list_total:0,

                course_id:'',
                user_id:0,
                is_show_share:false,
                is_loading:false, // 显示加载中
                more:false, //漫游消息是否有更多
                roomInfo:{},//房间信息

                scrollTop:0,
                scrollHeight:0, // 记录滚动高度
                scrollHDTop:0, // 记录互动区域的滚动位置
                toBottom:false, //显示滚动底部按钮
                autoScroll:true, //自动滚动底部
                bottomNewNews:false, // 底部消息按钮
                messageRetrying:false, // 消息连接断开

                type:'hd',

                msg_input:'',
                autosize: { maxHeight: 70, minHeight: 24 },
                checked:false,

                discuss:true,
                discuss_module:false,
                discussHeight:0,
                discuss_module_type:'tl',

                msg_discuss_input:'',
                discuss_checked:false,

                //弹幕开关
                bulletChat:true,
                bulletChatList:[],

                placeholder:'快来参与互动~',
                placeholderInit:'快来参与互动~', // 用于初始化变量
                replyMsgParams:{}, // 回复引用用户的数据体

                //直播信息
                live_params:{},
                videoCameraPlay:false,
                videoPPTStatus:false,
                currentPPT:0,
                playerOptions: {
                    //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "application/x-mpegURL",
                        src: "" //你的m3u8地址（必填）
                    }],
                    poster: "", //你的封面地址
                    controls:true, // 是否显示控件
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '直播连接中断，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true //全屏按钮
                    }
                },
                //快直播方式
                webrtc_issupport: false,  
                streamUrl: "",
                peerConnection: {},
                svrSig:"",
                isFirst:true,
                poster: "",
                tips: "消息连接已断开，请刷新重试"

            }
        },
        mounted() {
            this.course_id = this.util.getQueryStr('course_id');
            var source = 'h5';
            
            // 开始检查是否采用快直播方式
            
            console.log("socket",socket)
            const _this = this
            DectectRTC.support(function(res){
              if (res.h264Support && res.support) {
                console.log("当前环境支持: h264Suppor、webRTC ")
                _this.webrtc_issupport = true
                
              }else{
                console.warn("当前环境不支持: h264、webRTC ")
                _this.webrtc_issupport = false
              }
              _this.$nextTick(() => {
                  _this.preGetDetail()
              })
              
            });

            //浏览量+1
            this.util.server.event.event({
                data: {
                    message:{course_id:this.course_id,source:source},
                    code:10000,
                },
                callback: (res => {})
            });
            
        },
        updated(){

            var len = this.room_list.length;
            var as_len = this.ask_list.length;
            //互动区域不看学员
            if(len > this.room_list_total && this.room_list[len-1].room.ext.userRole != '学员' && !this.discuss_module && !this.autoScroll){
                this.bottomNewNews = true;
            }

            //讨论区域看全部
            if(len > this.room_list_total && this.discuss_module && !this.autoScroll && this.discuss_module_type=='tl'){
                this.bottomNewNews = true;
            }

            //提问区域看全部
            if(as_len > this.ask_list_total && this.discuss_module && !this.autoScroll && this.discuss_module_type=='tw'){
                this.askBottomNewNews = true;
                this.ask_list_total = this.ask_list.length;
            }

            this.room_list_total = this.room_list.length;

        },
        destroyed(){
            console.log("离开页面，清除socket")
            if(socket!=null){
              console.log("离开页面，关闭socket")
              socket.close()
            }
            socket = null
            clearTimeout(playerReadiedTime)
            clearTimeout(pingInterval)
            
        },
        methods:{
            preGetDetail(){
              if(this.util.globalData.user.get() == '' && this.util.sessionid.get() != ''){
                  this.util.server.mini_user.info({
                      callback:(res => {
                          this.util.getUserId.set(res.data.user_id);
                          this.util.user_mobile.set(res.data.mobile);
                          this.util.globalData.user.set(res.data);

                          this.user_id = this.util.getUserId.get();
                          this.getDetail();

                      })
                  })
              }else{
                  this.user_id = this.util.getUserId.get();
                  this.getDetail();
              }
            },
            usergrantcallback(e){
                this.visible=false;
                if(e.is_grant){
                    this.bindOrderCourse();
                }
            },
            socket(){
                var _self =this;
                socket = new WebSocket(env.base_config.liveHost);
                socket.onmessage = function (res) {
                    
                    if(res.data=='pong'){
                      console.log('心跳pong');
                      return false;
                    }
                    console.log(res.data)
                    try {
                        var data = JSON.parse(res.data);
                    } catch(e) {
                        console.log('error：'+res.data+'!!!'+e);
                        return false;
                    }

                    //进入房间
                    if(data.message == 'online'){
                        _self.sendEnterroom();
                    }

                    //获取房间信息
                    if(data.message == 'roomInfo'){
                        _self.roomInfo = data.roomInfo;
                        _self.live_params = data.roomInfo;

                        _self.videoCameraPlay = false;
                        if(data.roomInfo.type == 'video_ppt'){
                            _self.playerOptions.controls = false;
                            _self.live_height = '50'
                            _self.live_width = '100px'
                        }else{
                            _self.playerOptions.controls = true;
                            _self.live_height = _self.height
                            _self.live_width = '100%'
                        }

                        //如果当前状态为正在直播，则直接进行拉流
                        if(_self.isFirst && data.roomInfo.status=='start'){
                          _self.isFirst = false
                          console.log("直播进行中,进行初次拉取")
                          if(_self.webrtc_issupport){
                            setTimeout(function () {
                                _self.$nextTick(() => {
                                    _self.pullStream()
                                })
                            },3000)
                          }
                        }
                    }

                    //获取直播信息
                    if(data.message == 'live'){
                        if(data.live.page){
                            _self.live_params.page = data.live.page;
                        }
                        if(data.live.type){
                            _self.live_params.type = data.live.type;
                            _self.videoCameraPlay = false;

                            if(data.live.type == 'video_ppt'){
                                _self.playerOptions.controls = false;
                                _self.live_height = '50'
                                _self.live_width = '100px'
                            }else{
                                _self.playerOptions.controls = true;
                                _self.live_height = _self.height
                                _self.live_width = '100%'
                            }
                        }
                        if(data.live.ppts){
                            _self.live_params.ppts = data.live.ppts;
                        }
                        if(data.live.status){
                            _self.live_params.status = data.live.status;
                        }

                        // 如果浏览器支持快直播采用快直播进行播放
                        if(_self.webrtc_issupport){
                          setTimeout(function () {
                              _self.$nextTick(() => {
                                  console.log("拉取1111")
                                  _self.pullStream()
                              })
                          },3000)
                        }
                        
                    }

                    //聊天信息
                    if(data.message == 'room'){
                        _self.msg_list.push(data);
                        _self.room_list.push(data);

                        if(data.room.message.type == 'ask' ||
                            (data.room.message.quote && data.room.message.quote.fromMessage.message.type == 'ask')){
                            _self.ask_list.push(data)
                        }

                        if(data.room.message.type == 'text' || data.room.message.type == 'ask'){
                            _self.bulletChatList.push(data);
                            //删除第一个
                            if(_self.bulletChatList.length >=4){
                                _self.bulletChatList.splice(0,1);
                            }
                        }

                        if(_self.autoScroll){
                            _self.scrollToBottom();
                        }
                        if(_self.autoScroll && _self.discuss_module){
                            _self.scrollToBottomDiscuss();
                        }
                    }

                    //撤回信息
                    if(data.message == 'chatDel'){

                         _self.msg_list.some(function (item,index) {
                            if(data.chatDel.messageId == item.uuid){
                                return _self.msg_list.splice(index,1);
                            }
                         });

                        _self.ask_list.some(function (item,index) {
                            if(data.chatDel.messageId == item.uuid){
                                return _self.ask_list.splice(index,1);
                            }
                        });
                    }

                    //离线消息
                    if(data.message == 'offline'){
                        _self.tips = "对不起, 您已离线了"
                        _self.scrollToBottom();
                        _self.messageRetrying = true
                    }
                };

                socket.onopen = function (event) {
                    console.log("连接成功");

                    _self.messageRetrying = false;

                    //身份验证
                    _self.sendOnline();
                    _self.sendPing();
                };
                socket.onclose = function (event) {
                    console.log("链接关闭!..!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",socket);

                    _self.tips = "消息连接已断开，请刷新重试";
                    _self.messageRetrying = true;
                    _self.live_params.status = 'stop'

                    clearInterval(pingInterval);

                      if(socket!=null){ // 如果是主动关闭则不需要重连
                      _self.scrollToBottom();
                      // 关闭后进行重连
                      console.warn("已经断开，开始重连");
                      _self.socket()
                    }
                    
                };
            },
            //发送socket消息
            sendMsg(text){
                socket.send(JSON.stringify(text))
            },
            // 发送心跳，
            sendPing(){
              pingInterval = setInterval(()=>{
                  console.log("发送ping");
                  socket.send('ping')
              },1000*60)
            },
            //socket身份验证
            sendOnline(){
                var jsonText = {
                    "type":"control",
                    "message":"online",
                    "online":{
                        "userId": this.util.getUserId.get(),
                        "name": this.util.globalData.user.get().user_name,
                        "headimgurl": this.util.globalData.user.get().photo
                    }
                };
                this.sendMsg(jsonText);
            },
            //进入房间
            sendEnterroom(){
                var jsonText = {
                    "type":"control",
                    "message":"enterroom",
                    "enterroom":{
                        "roomId":this.course_id, //课程id
                        "role": this.params.role,//1、管理员 2、班班 3、学员
                        "ext": {
                            "userRole": this.params.userRole
                        }
                    }
                };
                this.sendMsg(jsonText);
            },
            //获取房间信息
            sendRoomInfo(){
                var jsonText = {
                    "type":"control",
                    "message":"roomInfo",
                    "roomInfo":{
                        "roomId":this.course_id, //课程id
                    }
                };
                this.sendMsg(jsonText);
            },

            //发送聊天消息
            // 如果提问打钩，这个时候回复别人信息的话以提问最大  提问>回复>普通发送
            sendMsgChat(){
                if(this.msg_input == ''){
                    return this.util.showToast({
                        message:'请输入内容'
                    })
                }
                var message={
                    "type":"text",
                    "text":{
                        "content": this.msg_input
                    }
                };
                if(this.replyMsgParams.uuid){
                    message = {
                        "type": "quote",
                        "quote":{
                            "fromMessage": {
                                "userInfo":this.replyMsgParams.room.userInfo,
                                "message":this.replyMsgParams.room.message
                            },
                            "content":this.msg_input ,
                        }
                    }
                }
                if(this.checked){
                    message = {
                        "type":"ask",
                        "ask":{
                            "content": this.msg_input
                        }
                    }
                }
                var jsonText = {
                    "type":"chat",
                    "message":"room",
                    "room":{
                        "roomId":this.course_id,
                        "message":message
                    }
                };
                this.sendMsg(jsonText);
                this.msg_input = '';
                this.discuss=true;
                this.removeReplyMsg();
                this.scrollToBottom();
            },
            //讨论区发送信息
            sendDiscussMsgChat(){
                if(this.msg_discuss_input == ''){
                    return this.util.showToast({
                        message:'请输入内容'
                    })
                }
                var message={
                    "type":"text",
                    "text":{
                        "content": this.msg_discuss_input
                    }
                };

                if(this.replyMsgParams.uuid){
                    message = {
                        "type": "quote",
                        "quote":{
                            "fromMessage": {
                                "userInfo":this.replyMsgParams.room.userInfo,
                                "message":this.replyMsgParams.room.message
                            },
                            "content":this.msg_discuss_input ,
                        }
                    }
                }
                if(this.discuss_checked){
                    message = {
                        "type":"ask",
                        "ask":{
                            "content": this.msg_discuss_input
                        }
                    }
                }
                var jsonText = {
                    "type":"chat",
                    "message":"room",
                    "room":{
                        "roomId":this.course_id,
                        "message":message
                    }
                };
                this.sendMsg(jsonText);
                this.msg_discuss_input = '';
                this.removeReplyMsg();
                this.scrollToBottomDiscuss();
            },
            //获取漫游消息
            getImList(load){
                var _self = this;

                this.util.server.mini_im.list({
                    data:{
                        room_id: this.course_id,
                        indexes:this.indexes,
                    },
                    is_show_load:load,
                    callback:(res=>{

                        const {code,data,msg}= res ;
                        if(code == -1){return}

                        _self.more = data.more;

                        if(data.items.length > 0){
                            _self.msg_list = data.items.concat(_self.msg_list);

                            _self.is_loading = false;

                            if(_self.indexes == ''){
                                _self.scrollTo();

                                //弹幕只取3条数据
                                var len = _self.msg_list.length-1;
                                var arr = [];
                                for (var i = len; i>=0;i--){
                                    if(arr.length ==3){
                                        break;
                                    }
                                    if(_self.msg_list[i].room.message.type == 'text' ||
                                        _self.msg_list[i].room.message.type == 'ask'){
                                        arr.push(_self.msg_list[i]);
                                    }
                                }
                                for (var i = arr.length-1;i>=0 ;i--){
                                    _self.bulletChatList.push(arr[i]);
                                }
                            }else{
                                _self.$nextTick(() => {
                                    if(this.discuss_module){

                                        var container = document.querySelector('.discuss');
                                        container.scrollTop = container.scrollHeight - _self.scrollHeight -50;

                                        //防止评论区的滚动加载数据增多导致互动区域的滚动位置发生变化
                                        document.querySelector('.hd').scrollTop = container.scrollHeight - container.clientHeight - _self.scrollHDTop
                                    }else{
                                        var container = document.querySelector('.hd');
                                        container.scrollTop = container.scrollHeight - _self.scrollHeight -50;
                                    }
                                })
                            }
                            _self.indexes = data.items[0].indexes;

                        }else{
                            _self.is_loading = false;
                        }
                    })
                })
            },
            //获取提问区消息
            getAskList(){
                var _self = this;

                this.util.server.mini_im.list({
                    data: {
                        room_id: this.course_id,
                        indexes: this.ask_indexes,
                        business_label:'ask',
                        pagesize:10
                    },
                    is_show_load: false,
                    callback: (res => {
                        const {code,data,msg}= res ;
                        if(code == -1){return}

                        _self.ask_more = data.more;

                        if(data.items.length > 0){
                            _self.ask_list = data.items.concat(_self.ask_list);
                            _self.ask_list_total = _self.ask_list.length;

                            _self.ask_is_loading = false;

                            if(_self.ask_indexes != ''){
                                _self.$nextTick(() => {
                                    if(this.discuss_module && this.discuss_module_type == 'tw'){

                                        var container = document.querySelector('.ask');
                                        container.scrollTop = container.scrollHeight - _self.scrollHeight -50;
                                    }
                                })
                            }else{
                                _self.scrollTo();
                            }

                            _self.ask_indexes = data.items[0].indexes;
                        }else{
                            _self.ask_is_loading = false;
                        }
                    })
                })
            },
            //获取直播课详情
            getDetail(){
                var _self = this;

                this.util.server.yzx.live_detail({
                    data:{
                        course_id: this.course_id
                    },
                    callback:(res=>{

                        document.title=res.data.name

                        if(res.data.is_own == 0){
                            this.type = 'kc';
                        }
                        if (res.data.content) {
                            res.data.content = res.data.content.replace(/<img/gi,'<img style="max-width:100%;height:auto"');
                        }
                        this.params=res.data;
                        // this.playerOptions.sources[0].src='https://liveplay.xiaoeknow.com/live/5060_PSHs4XmGMc3fnwGw.m3u8?time=1604634557944';
                        this.playerOptions.sources[0].src='https://live.bysjy.com.cn/live/1400338336_'+this.course_id+'_'+res.data.create_by+'_main.m3u8';
                        this.playerOptions.poster = res.data.cover;

                        if(this.webrtc_issupport){
                          this.streamUrl= 'webrtc://live.bysjy.com.cn/live/1400338336_'+this.course_id+'_'+res.data.create_by+'_main'
                          this.poster = res.data.cover
                          //this.pullStream()
                        }

                        this.bindType(this.type);
                        this.bodyShow=true;
                        this.getHeight();

                        this.util.jweixin(function (wx) {
                            WeChat =wx;
                            _self.bindWxShare();
                        });
                        
                    })
                })
            },
            getStreamId(url){
              //var url = "webrtc://domain/path/stream_id[?txSecret=xxx&txTime=xxx]";
              var parseStreamid = /^(?:webrtc:\/\/)(?:[0-9.\-A-Za-z_]+)(?:\/)(?:[0-9.\-A-Za-z_]+)(?:\/)([^?#]*)(?:\?*)(?:[^?#]*)/;
              var result = parseStreamid.exec(url);
              if(result)
                  return result[1];
              return null;
            },
            onAddStream(e){
              console.log(`onAddStream, streamId:${e.streamId}`, e.stream);
              var video = this.$refs.webrtc_live;
              video.srcObject = e.stream;
              //video.muted = true
              video.autoplay = true
              video.playsinline = true

              if(env.iOS && !env.wechatdevtools){
                  console.log("IOS 自动播放机制")
                  WeixinJSBridge.invoke('getNetworkType',{},function (e){
                    console.log("IOS 执行自动播放")
                    video.play();
                  });
              }else{
                console.log("安卓自动播放机制")
                var playPromise = video.play();
                 if(playPromise){
                    playPromise.then(() => {
                        console.log(`play ok!`);
                    }).catch(() => {
                        console.log(`play failed!`);
                  });
                 }
              }
              
            },
            pullStream() {
              const _self = this
              console.log("startLive")
              var clientInfo = "clientinfo_test";
              var sessionId = "sessionId_Test";
              var streamId = this.getStreamId(this.streamUrl);
              var video = this.$refs.webrtc_live;
              
              var config = {
                  iceServers: [],
                  bundlePolicy: "max-bundle",
                  rtcpMuxPolicy: "require",
                  tcpCandidatePolicy: "disable",
                  IceTransportsType: "nohost",
                  sdpSemantics: 'unified-plan'
              };

              var optional = {
                  optional: [{
                      DtlsSrtpKeyAgreement: true
                  }]
              };

              var offerSdpOption = {
                  offerToReceiveAudio: true,
                  offerToReceiveVideo: true,
                  voiceActivityDetection: false
                };

              this.peerConnection = new RTCPeerConnection(config, optional);
              this.peerConnection.onicecandidate = function(e) {
                  console.log("peerConnection.onicecandidate:", e);
              };

              this.peerConnection.onaddstream = function(e) {
                  console.log("peerConnection.onaddstream");
              };

              this.peerConnection.onremovestream = function(e) {
                  console.log("peerConnection.onremovestream");
              };
              
              this.peerConnection.ontrack = function(e) {
                  console.log("peerConnection.ontrack, kind:" + e.track.kind + ",track.id:" + e.track.id);

                  var track = e.track;
                  if(!_self.peerConnection.stream){
                      _self.peerConnection.streamId = streamId;
                      _self.peerConnection.stream = new MediaStream();
                      _self.peerConnection.stream.addTrack(track);

                      _self.onAddStream(_self.peerConnection);
                  } else{
                      _self.peerConnection.stream.addTrack(track);
                      console.log("track.lenght:" + _self.peerConnection.stream.getTracks().length);
                  }
              };

              this.peerConnection.onconnectionstatechange = function(e) {
                  console.log("onconnectionstatechange", e);
              }

              this.peerConnection.oniceconnectionstatechange = function(e) {
                  console.log("peerConnection.oniceconnectionstatechange: " + JSON.stringify(e), e);
              };

              this.peerConnection.onicegatheringstatechange = function(e) {
                  console.log("peerConnection.onicegatheringstatechange : " + e.target.iceGatheringState, e);
              };

              this.peerConnection.onsignalingstatechange = function(e) {
                  console.log("peerConnection.onsignalingstatechange : " + _self.peerConnection.signalingState, e);
              };

              this.peerConnection.onnegotiationneeded = function(e) {
                  console.log("peerConnection.onnegotiationneeded", e);
              };


              this.peerConnection.createOffer(offerSdpOption).then(function(offer) {
                console.log('this.peerConnection!!!!!!!!!!!!!!!!!!' + _self.peerConnection);
                var stringSdp = offer.sdp.toString();
                var arrSdp = stringSdp.split("\r\n");
                var stringSdpModify = ""; 
                    
                for (var i=0;i<arrSdp.length-1;i++)
                {            
                    if (arrSdp[i].lastIndexOf("a=fmtp:111") != -1) {
                        stringSdpModify += arrSdp[i] + ";stereo=1" + "\r\n";
                    } else {
                        stringSdpModify += arrSdp[i] + "\r\n";
                    }   
                }   
                offer.sdp = stringSdpModify;
                console.log("peerConnection.split3", offer.sdp);

                _self.peerConnection.setLocalDescription(offer);

                var url = "https://webrtc.liveplay.myqcloud.com/webrtc/v1/pullstream"; 
                console.log('_self.streamUrl', _self.streamUrl)
                var reqBody = {
                    streamurl: _self.streamUrl,
                    sessionid:  sessionId,
                    clientinfo: clientInfo,
                    localsdp: offer
                };

                $.ajax({
                    type: "post",
                    url: url,
                    data: JSON.stringify(reqBody),
                    //contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: pullStreamRes,
                    crossDomain: true
                });
                //fly.interceptors.request.use((request) => {
                //   request.headers['Content-Type'] ='application/json';
                //   request.headers['Access-Control-Allow-Origin'] ='*';
                //   request.headers['Access-Control-Allow-Credentials'] ='true';
                //})
                //fly.post(url, JSON.stringify(reqBody)).then(pullStreamRes).catch(function(error){
                //   console.log("fly post err:", error);
                //});

                function pullStreamRes(data){
                    console.log("pullStreamRes:", data);
                //    data = data.data;
                    var errCode = data.errcode;
                    var errMsg = data.errmsg;
                    if(errCode != 0){
                        console.log(`pull stream failed!errCode:${errCode}, errmsg:${errMsg}`);
                        return;
                    }

                    var remoteSdp = data.remotesdp;
                    _self.svrSig = data.svrsig;

                    console.log(`svrSig:${_self.svrSig}`);

                    console.warn("tag !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

                    _self.peerConnection.setRemoteDescription(
                        new RTCSessionDescription(remoteSdp),
                        function(){
                            console.log("setRemoteSdp succ!");
                        },
                        function(e){
                            console.log("setRemoteSdp failed, exception = " + e.message);
                        }
                    );
                }
              }).catch(function(reason) {
                  console.log('create offer failed : reason =111111111 ' + reason);
              });
              

            },
            //免费领取
            bindOrderCourse(){
                if(!this.util.user_mobile.get()){
                   return this.visible = true;
                }
                this.util.server.mini_pay.order_course({
                    data: {
                        course_id: this.course_id,
                        pay_money: 0,
                        coupon_user_id: '',
                        sum_money: 0,
                        coupon_money: 0

                    },
                    callback: (res => {
                        if(res.code == 1){
                            location.reload();
                        }
                    })
                })
            },
            bindWxShare:function(){
                console.log('执行分享1')
                if(!WeChat){
                    return false;
                }
                var _self=this;
                var link = location.href;
                if(location.href.indexOf('&current=') == -1){
                    link = link +'&u_id='+_self.util.getUserId.get()
                }else{
                    link = 'https://'+location.host+this.util.urlPrefix+'/live/index?course_id='+this.course_id+'&token='+this.util.token+'&u_id='+_self.util.getUserId.get()
                }
                console.log('执行分享2')
                this.util.wxShare(WeChat, {
                    title: _self.params.name,
                    desc: _self.params.desc,
                    link: link,
                    imgUrl: _self.params.cover
                });
            },
            //购买课程
            bindApply(){
                this.util.payRedirect.set(location.href);
                location.href = this.util.urlPrefix+'/payment/index?id='+this.course_id+'&token='+this.util.token;
                // this.$router.push(this.util.urlPrefix+'/payment/index?id='+this.course_id+'&token='+this.util.token)
            },
            hideShare(e){
                this.is_show_share = e;
            },
            //消息滚动最底部
            msgScroll(e){
                //原始高度
                var height = e.target.scrollHeight-e.target.clientHeight;
                var scrollTop = e.target.scrollTop;
                var scroll = scrollTop - this.scrollTop;
                this.scrollTop = e.target.scrollTop;

                if(!this.discuss_module){
                    this.scrollHDTop = height - scrollTop;
                }

                if(scroll <0){
                    // console.log(scrollTop,"上")]
                    if(this.discuss_module_type == 'tl'){
                        this.toBottom = false;
                    }
                    if(this.discuss_module_type == 'tw'){
                        this.askToBottom = false;
                    }

                    this.autoScroll = false;

                    if(scrollTop <=20 && this.more && !this.is_loading && this.discuss_module_type == 'tl'){
                        this.is_loading = true;
                        this.scrollHeight = e.target.scrollHeight;
                        this.getImList(false);
                    }

                    if(scrollTop <=20 && this.ask_more && !this.ask_is_loading && this.discuss_module_type == 'tw'){
                        this.ask_is_loading = true;
                        this.scrollHeight = e.target.scrollHeight;
                        this.getAskList();
                    }

                }else{
                    // console.log(scrollTop,"下")
                    if(this.discuss_module_type == 'tl'){
                        this.toBottom = true;
                    }
                    if(this.discuss_module_type == 'tw'){
                        this.askToBottom = true;
                    }

                    //是否显示到底按钮 100是设置距离底部还剩多少高
                    if(height - scrollTop < 100 && this.discuss_module_type == 'tl'){
                        this.toBottom = false;
                    }

                    if(height - scrollTop < 100 && this.discuss_module_type == 'tw'){
                        this.askToBottom = false;
                    }
                }

                //接收消息自动滚动到最底部
                if(height - scrollTop < 30){
                    this.autoScroll = true;

                    if(this.discuss_module_type == 'tl'){
                        this.bottomNewNews = false;
                    }

                    if(this.discuss_module_type == 'tw'){
                        this.askBottomNewNews = false;
                    }
                }
            },
            scrollTo(time){
                if(this.discuss_module){
                    this.scrollToBottomDiscuss(time);
                }else{
                    this.scrollToBottom(time);
                }
            },
            scrollToBottom(time) {
                var _self =this;
                var t = time || 300;
                setTimeout(function () {
                    _self.$nextTick(() => {
                        var container = document.querySelector('.hd');
                        container.scrollTop = container.scrollHeight;
                    })
                },t)
            },
            scrollToBottomDiscuss(time){
                var _self =this;
                var t = time || 300;
                setTimeout(function () {
                    _self.$nextTick(() => {
                        if(_self.discuss_module_type == 'tl'){
                            var container = document.querySelector('.discuss');
                        }else{
                            var container = document.querySelector('.ask');
                        }
                        container.scrollTop = container.scrollHeight;
                    })
                },t)
            },
            getHeight(){
                this.innerHeight = window.innerHeight;
                var windowWidth = document.documentElement.clientWidth;
                var proportion = 7.5;
                if(windowWidth>=480){
                    windowWidth = 480;
                    proportion = 9.6;
                }else{
                    proportion = 7.5;
                }

                this.height = windowWidth / proportion * 4.22;
                this.live_height = this.height
                this.msgWidth = windowWidth / proportion * 4.9;

                this.$nextTick(() => {
                    this.discussHeight = document.querySelector('.msg-col').clientHeight;
                })
            },
            bindType(type){
                this.type = type;

                switch (this.type) {
                    case 'hd':
                        if(!socket){
                            this.socket();
                        }
                        if(this.msg_list.length == 0){
                            this.getImList();
                        }
                        break;
                }
            },
            //输入框获取焦点事件
            msgFocus(){
                this.discuss=false;
            },
            //输入框失去焦点事件
            msgBlur(){
                if(this.msg_input != ''){
                    return ;
                }
                this.removeReplyMsg();
                this.discuss=true;
            },
            msgDiscussBlur(){
                if(this.msg_discuss_input != ''){
                    return ;
                }
                this.removeReplyMsg();
                this.scrollToBottomDiscuss();
            },
            //打开讨论区
            openDiscuss(){
                this.discuss_module = true;
                this.scrollToBottomDiscuss();
                this.initScroll();
            },
            initScroll(){
                this.scrollTop = 0;
                this.scrollHeight = 0;
                this.toBottom = false;
                this.autoScroll = true;
                this.bottomNewNews = false;
                this.askBottomNewNews = false;
                this.messageRetrying = false;
                this.discuss_module_type = 'tl';
                this.removeReplyMsg();
            },
            //关闭讨论区
            closeDiscuss(){
                this.discuss_module = false;
                this.initScroll();
            },
            //讨论模板type切换
            bindDiscussModuleType(type){
                this.discuss_module_type = type;
                switch (type) {
                    case 'tw':
                        if(this.ask_list.length == 0){
                            this.ask_is_loading=true;
                            this.getAskList();
                        }
                        break;
                }
            },
            //查看图片
            openImagePreview(img){
                ImagePreview([
                    img
                ]);
            },
            //撤回消息
            withdrawMsgEvent(id){
                var _self = this;
                Dialog.confirm({
                    title: '撤回信息',
                    message: '确定撤回本条信息？',
                }).then(() => {
                    // on confirm

                    var jsonText = {
                        "type":"control",
                        "message":"chatDel",
                        "chatDel":{
                            "roomId":_self.course_id,
                            "messageId":id
                        }
                    };
                    this.sendMsg(jsonText);

                }).catch(() => {
                    // on cancel

                });
            },
            //跳转
            jumpEvent(item){
                switch (item.type) {
                    case 'course':
                        this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+item.id+'&token='+this.util.token);
                        break;
                }
            },
            //弹幕
            bulletChatEvent(){
                this.bulletChat = this.bulletChat?false:true;
            },
            //回复消息
            replyMsg(item,msg){
                var item = JSON.parse(JSON.stringify(item));
                if(msg.fromMessage){
                    item.room.message={
                        type:'text',
                        text:{
                            content:msg.content
                        }
                    }
                }else{
                    item.room.message=msg;
                }
                this.replyMsgParams = item;
                this.placeholder = '回复：'+item.room.userInfo.name;

            },
            //清楚回复消息
            removeReplyMsg(){
                this.placeholder=this.placeholderInit;
                this.replyMsgParams={};
            },
            //PPT直播图片点击事件
            openLivePPT(){
                ImagePreview({
                    images: this.live_params.ppts,
                    startPosition:(this.live_params.page-1),
                });
            },
            livePPTTouchmove(){
                this.util.showToast({
                    message:'请点击放大后进行翻页操作'
                })
            },
            //屏幕共享/摄像头直播错误事件监听
            playerReadied(player) {
                var _self = this;
                if(player.error_ && player.error_.code == 4){
                    if(this.live_params.type != 'video_ppt'){
                        this.live_params.type = '';
                        this.videoPPTStatus = false;
                    }else{
                        this.videoPPTStatus = true;
                    }
                    clearTimeout(playerReadiedTime);
                    return false;
                }
                playerReadiedTime = setTimeout(function () {
                    _self.playerReadied(player);
                },0)
            },
            //播放
            videoPlay(){
                if(this.videoPPTStatus){
                    return this.util.showToast({
                        message:'视频采集失败，刷新再试试'
                    })
                }
                //播放
                if(this.videoCameraPlay){
                    this.videoCameraPlay = false;
                    document.querySelector('video').pause();
                }else{
                    //停止
                    this.videoCameraPlay = true;
                    document.querySelector('video').play();
                }
            },
            //全屏
            videoFullscreen(){
                if(this.videoPPTStatus){
                    return this.util.showToast({
                        message:'视频采集失败，刷新再试试'
                    })
                }
                var videoObj = document.querySelector('video');
                if(videoObj.requestFullScreen) {
                    videoObj.requestFullScreen();
                } else if(videoObj.mozRequestFullScreen) {
                    videoObj.mozRequestFullScreen();
                } else if(videoObj.webkitRequestFullScreen) {
                    videoObj.webkitRequestFullScreen();
                }

                // this.playerOptions.controls = true;
                document.querySelector('video').play();
            },
            // listen event
            onPlayerPlay(player) {
                if(this.videoPPTStatus){
                    return this.util.showToast({
                        message:'视频采集失败，刷新再试试'
                    })
                }
                this.videoCameraPlay = true;
            },
            onPlayerPause(player) {
                this.videoCameraPlay = false;
            },

            onPlayerTimeupdate(player) {
                if(player.player_.isFullscreen_ == true){
                    this.playerOptions.controls = true;
                }else{
                    this.playerOptions.controls = false;
                }
            },

        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .page{
        height: 100%;
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .video-col{
        width: 100%;
        position: relative;
    }
    .video-col .video-no {
        width: 100%;
        height: 100%;
    }
    .video-col .video-no .van-image{
        width: 100%;
        height: 100%;
    }
    .video-no .video-mask{
        position: absolute;
        top: 0;
        background: rgba(0,0,0,.5);
        left: 0;
        width: 100%;
        height: 100%;
    }
    .video-mask .video-mask-info{
        color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
    }
    .video-mask-info .iconfont{
        display: block;
        text-align: center;
        font-size: 48px;
        margin-bottom: 10px;
        margin-top: -5px;
    }
    .video-col .video-no img{
        width: 100%;
        height: 100%;
    }
    .msg-col{
        display: flex;
        flex: 1;
        flex-direction: column;
        width: 100%;
        height: 100%;
        position: relative;
    }
    .table{
        display: table;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
    }
    .table .tab-li{
        background-color: #fff;
        display: table-cell;
        font-size: 16px;
        min-width: 74px;
        padding: 0 5px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        position: relative;
    }
    .table .tab-li.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 42px;
        height: 3px;
        background: rgba(52, 155, 248, 1);
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -21px;
    }
    .table-content{
        width: 100%;
        height: 100%;
        display: flex;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .table-content-li{
        padding: 10px;
        width: 100%;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .hd{
        position: absolute;
        top: 0;
        bottom: 56px;
    }
    .live-no-own{
        position: absolute;
        background: rgba(255,255,255,0.95);
        top: 0;
        width: 100%;
        height: 100%;
    }
    .live-own-tip{
        position: absolute;
        width: 100%;
        text-align: center;
        top: 50%;
        margin-top: -60px;
    }
    .fs30{
        font-size: 30px;
    }
    .mt5{
        margin-top: 5px;
    }
    .kc{
        background-color: #fff;
    }
    .kc .live-name{
        font-weight: bold;
    }
    .kc .live-lecturer{
        margin: 10px 0;
    }
    .kc .live-brief-introduction{
        margin: 10px 0;
        font-weight: bold;
    }
    .kc .live-brief-txt{
        font-size: 12px;
        margin: 10px 0;
        color: #999;
    }
    .kc .live-course-time{
        font-size: 12px;
        margin: 10px 0;
        color: #999;
    }
    .admin-img,.live-msg-li .user-img{
        height: 30px;
        width: 30px;
        float: left;
        font-size: 0;
    }
    .admin-img img,.live-msg-li .user-img >>> img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #fff;
    }
    .admin-info,.user-info{
        float: left;
        margin-left: 5px;
        margin-bottom: 5px;
    }
    .admin-name,.user-name{
        margin-bottom: 5px;
        color: #666;
    }
    .fs2{
        font-size: 12px;
    }
    .clearfix:after{
        content: "";
        display: table;
        clear: both;
    }
    .admin-content,.user-content{
        display: inline-block;
        background-color: #fff;
        padding: 8px 10px;
        box-sizing: border-box;
        line-height: 1.6;
        border-radius: 5px;
        box-shadow: 0 0 1px #ccc;
        white-space: pre-line;
        word-break: break-all;
    }
    .live-msg-img{
        font-size: 0;
    }
    .live-msg-img >>> img{
        width: auto;
        max-width: 100%;
        max-height: 24vh;
    }
    .live-msg-card{
        background-color: #fff;
        border-radius: 5px;
        font-size: 0;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .live-msg-card .van-image{
        border-radius: 5px;
    }
    .live-msg-card span{
        display: inline-block;
        padding: 8px 10px;
        font-size: 12px;
    }
    .live-msg-time{
        color: #888;
        text-align: center;
        /*padding-top: 10px;*/
        font-size: 12px;
        margin-bottom: 0.625rem;
    }
    .live-msg-list .live-msg-li{
        width: 100%;
        height: 100%;
        margin-top: 10px;
    }
    .user-name .user-lecturer{
        color: #fff;
        background-color: #8f94b4;
        font-size: 12px;
        margin-right: 5px;
        padding: 2px 4px;
        border-radius: 3px;
    }
    .fr .user-lecturer{
        margin-right: 0;
        margin-left: 5px;
    }
    .reply-content{
        word-break:break-all;
    }
    .question-sign{
        color: #fff;
        background-color: #09bb07;
        border-radius: 50%;
        display: inline-block;
        height: 20px;
        width: 20px;
        text-align: center;
        line-height: 20px;
        margin-right: 5px;
        font-size: 12px;
    }
    .user-content >>> .van-divider{
        border-color:#3a3a3a
    }
    .fr{
        float: right !important;
    }
    .mr{
        margin: 0 5px 5px 0;
    }
    .withdraw-msg{
        color: #576b95;
        margin-right: 5px;
        font-size: 12px;
    }
    .live-btn{
        padding: 8px 16px;
        position: fixed;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
    .live-btn .live-btn-text{
        flex: 1;
    }
    .live-btn-text >>> .van-cell{
        padding: 8px 12px;
        background-color: #f9f9f9;
        border-radius: 20px;
    }
    .live-btn-text >>> .van-field__button .van-checkbox__label{
        font-size: 12px;
        color: #999;
    }
    .live-discuss-module{
        padding: 0 0 0 10px;
    }
    .live-msg-save{
        color: #09bb07;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        margin-left: 15px;
    }
    .discuss-module{
        background-color:#f8f9fb;
    }
    .discuss-head{
        display: flex;
    }
    .discuss-head-col{
        flex: 1;
        padding: 12px 0;
        font-size: 16px;
        text-align: center;
        position: relative;
    }
    .discuss-head-close{
        padding: 15px;
    }
    .discuss-head .discuss-head-col.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 42px;
        height: 3px;
        background: rgba(52, 155, 248, 1);
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -21px;
    }
    .make-an-appointment{
        position: fixed;
        bottom: 0;
        width: 100%;
        border: 1px solid #ccc;
        background-color: #fff;
        display: flex;
    }
    .share{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 0 15px;
        line-height: 39px;
        background-color: #fff;
        border-radius:0;
    }
    .share::after{
        content: '';
        width: 0;
        height: 0;
    }
    .trial-class{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 10px 20px;
    }
    .make-an-appointment-text{
        display: inline-block;
        text-align: center;
        background-color: #FF6600;
        color: #fff;
        border-right: 1px solid #ccc;
        padding: 10px;
        flex: 1;
    }
    .to-bottom{
        position: absolute;
        right: 10px;
        bottom: 66px;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        color: #fff;
        text-align: center;
        line-height: 25px;
        background-color: rgba(53,53,53,.6);
        z-index: 999999;
    }
    .to-bottom span{
        font-weight: bold;
    }
    .bottom-new-news{
        position: absolute;
        bottom: 64px;
        width: 100%;
        font-size: 12px;
        text-align: center;
        z-index: 999999;
    }
    .bottom-new-news span{
        background-color: rgba(255, 255, 255, .8);
        color: #1989fa;
        padding: 5px 10px;
    }
    .message-retrying{
        color: #999;
        font-size: 12px;
        text-align: center;
        width: 100%;
    }
    .bullet-chat{
        position: absolute;
        right: 10px;
        bottom: 66px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color:#fff;
        box-shadow: 0 0.06rem 0.2rem 0 rgba(0,0,0,.05);
    }
    .bullet-chat span{
        font-size: 28px;
    }
    .barrage-list{
        position: absolute;
        right: 10px;
        bottom: 115px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .barrage-item{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,.5);
        padding: 2px;
        border-radius: 15px;
        max-width: 140px;
        margin-bottom: 5px;
    }
    .barrage-item-txt{
        flex: 1;
        margin-right: 5px;
        font-size: 12px;
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .barrage-item-img{
        font-size: 0;
    }
    .barrage-item-img img{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
    }
    .barrage-item-txt .question-tip{
        background-color: #fff;
        color: #666;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        display: inline-block;
        line-height: 18px;
        text-align: center;
    }
    .barrage-item-txt .content-area{
        margin-left: 5px;
    }
    .live-room-info{
        position: absolute;
        top: 3px;
        background-color: #fff;
        padding: 3px 9px;
        border-radius: 0 10px 10px 0;
        color: #09bb07;
        font-size: 12px;
        box-shadow: 0 0.06rem 0.2rem 0 rgba(0,0,0,.05);
    }
    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 5px;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
    }
    .camera-video{
        height: 50px;
        background-color: #474747;
        display: flex;
        overflow: hidden;
    }
    .camera-video-btn{
        display: flex;
        flex: 1;
        margin-left: 110px;
    }
    .camera-video-btn .tip{
        color: #09bb07;
        font-weight: 700;
        line-height: 50px;
        flex: 1;
    }
    .tip.stop{
        color: #f30;
    }
    .camera-video-play,.camera-fullscreen{
        color: #ddd;
        line-height: 50px;
    }
    .camera-video-play{
        margin-right: 26px;
    }
    .camera-fullscreen{
        margin-right: 18px;
    }
    .camera-video-btn .iconfont{
        font-size: 22px;
    }
    .live-zone{
      position: relative;
    }
    #webrtc_live{
      position: absolute;
      top:0px;
    }
    /* 解决快直播兼容样式 */
    .camera-video-player{
      position: absolute;
      top:0px;
    }
</style>
<!-- video 样式 -->
<style scoped>

    .video-content{
        font-size: 0;
    }
    .video-content >>> .video-js .vjs-volume-panel{
        display: none;
    }
    .video-content >>> .vjs-live-display{
        display: none;
    }
    .video-content >>> .vjs-audio-button{
        display: none;
    }
    .video-content >>> .vjs-current-time{
        display: none !important;
    }
    .camera-video >>> .vjs-error-display{
        display: none !important;
    }
    .video-content >>> .video-js .vjs-big-play-button{
        height: 50px !important;
        width: 50px;
        margin-left: -25px;
        border-radius: 50%;
        border: 0;
        line-height: 50px !important;
    }
    .video-content >>> .video-js{
        padding-top: 43%;
        height: 100%;
    }
    .video-content >>> .vjs-error .vjs-error-display:before{
        content: '';
    }
    .camera-video >>> .vjs-fluid{
        padding-top:50%;
    }
    .camera-video >>> .vjs-big-play-button{
        border: 0;
    }
    .camera-video >>> .video-js .vjs-volume-panel{
        display: none;
    }
    .camera-video >>> .vjs-live-display{
        display: none;
    }
    .camera-video >>> .vjs-audio-button{
        display: none;
    }
    .camera-video >>> .vjs-current-time{
        display: none !important;
    }
    .camera-video >>> .vjs-error-display{
        display: none !important;
    }
</style>
